import React, { useState, useEffect,useCallback } from "react";
import Breadcrumbs from "components/Breadcrumbs";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import EstimatesTable from "./estimatesTable";
import DeleteModal from "components/modelpopup/DeleteModal";
import { getExpenseApi, getExpensesApi , deleteExpenseApi} from "api/services/expense";
import {itemRender, handlePageChange, defaultPagination, pageSizeOptions} from "utils/table";
import {  useNavigate } from "react-router-dom";
import { Table , Pagination} from "antd";
import { useSearchParams, useLocation } from 'react-router-dom';
import { formatDateHandler2 } from "utils/common";
import Image from "components/Image";
import { filterHandler } from 'utils/common';
import useExpensesFilter from "./hooks/filterHook"
import {  useSelector } from 'react-redux';
import ExpensesFilter from "./components/expensesFilter"
import  FilterDrawer from "components/Drawer/expensesFilterDrawer"
import {format} from "date-fns"
import ExpenseModal from "components/modelpopup/createExpenseModal";
import { SkeltonLoader } from "components/skeltonLoader";
import { useMediaQuery } from "react-responsive";
import { Button } from "components/Button";
import { toast, Bounce } from "react-toastify";
import { primaryRedGradient } from "utils/constants";

import ExpenseStatusModal from "components/modelpopup/changeExpenseStatusModal";

const Estimates = () => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const [dateTwo, setdateTwo] = useState(false);
  const [setSelectedOption] = useState(null);
  const [selectedDateTwo, setSelectedDateTwo] = useState(null);

  
  const [loading, setLoading] = useState(false)
  const [expenses, setExpenses] = useState([])
  const [expensesLoading, setExpensesLoading] = useState(false);
  const [showFilterDrawer, setShowFilterDrawer] = useState(false)
  const [selectedExpense, setSelectedExpense] = useState("");
  const [expenseModal, setExpenseModal] = useState(false);
  const [expenseStatusModal, setExpenseStatusModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const [appliedFilterCount, setAppliedFilterCount] = useState(0);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [view, setView] = useState(isMobile? "grid":"list");

  const {
    user, userLoading   
} = useSelector((state) => state.user);
  const navigate = useNavigate();

  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  

  useEffect(()=>{
    // console.log(id, modal, "MMM")
    const id = queryParams.get("id"); // Get 'id' param
    const modal = queryParams.get("modal"); // Get 'name' param
    // const { search } = useLocation();
    // const queryParams = new URLSearchParams(location?.search);
    console.log(queryParams, id ,  modal, queryParams,"MMM")

    if(id && modal){
      getExpenseApi(id, {}).then(response=>{
        setSelectedExpense(response?.data)
        setExpenseStatusModal(true)
      })
      
    }

  },[])


  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_byb") || "",

})
const { handleFilterChange,
  filters,
  handleInputChange, filterLoading, setFilterLoading, handleDateChange} = useExpensesFilter(pageSettings , setPageSettings);

  


const getFilterParams = useCallback(()=>{
  let filter_params = filterHandler(filters)

    return filter_params
        
})
useEffect(()=>{
  setExpenseParams(pageSettings)
},[pageSettings])

const setExpenseParams = (pageData) => {
  let filter_params = getFilterParams()
  let params = {
      size: pageData?.pageSize,
      page: pageData?.page,
      sort_by: pageData?.sortBy || "",
      sort_type: pageData?.sortType || "",
      ...filter_params
  }
  setSearchParams(params)
}
  const fetchExpensesList = () => {
    setLoading(true)
    setExpensesLoading(true)
    let filter_params = getFilterParams()   
    if(filter_params?.reference_date){
      filter_params.reference_date = format(new Date(filter_params.reference_date), "yyyy-MM-dd")
  }
  if(filter_params?.posting_date){
      filter_params.posting_date = format(new Date(filter_params.posting_date), "yyyy-MM-dd")
  }


    getExpensesApi({
      sort_by:pageSettings?.sortBy,
      sort_type: pageSettings?.sortType,
      page_size: pageSettings?.pageSize,
      page: pageSettings?.page,
      ...filter_params

    }).then(res => {
      if(view=="grid" && pageSettings?.page!==1){
        setExpenses([...expenses,...res.data.results]);

      }else{
        setExpenses(res.data.results)

      }

      setPageSettings({
        ...pageSettings,
        total: res.data.count
    })
      setLoading(false)
      setShowFilterDrawer(false)
      setExpensesLoading(false)

    }).catch(e=>{
      setExpenses([])
      setLoading(false)
      setExpensesLoading(false)
    })

  }
  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
    setPageSettings(pageData)
  };

  const handleExpenseAction = (record)=>{
    setSelectedExpense(record)
    setExpenseModal(true)
  }
  const handleExpenseStatusAction = (record)=>{
    setSelectedExpense(record)
    setExpenseStatusModal(true)
  }
  const handleFilterDrawer = () => {
    console.log("JJJJJJJ")
    setShowFilterDrawer(!showFilterDrawer)
    setFilterLoading(false)
  }
  const handleApplyFilter = () => {   
  
    let _appliedFilters = filters.filter(item=> item.value && item.key != "search");
    setAppliedFilterCount(_appliedFilters.length) 
  
    // setFilterLoading(true)
    setPageSettings({
        ...pageSettings,
        page: 1,
        filters
      })
    // getEmployeeList()


  }

  useEffect(()=>{
    fetchExpensesList()
  },[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters])

  const handleDeleteAction = (record) => {
    setSelectedExpense(record);
    setDeleteModal(true);
  }
  
  const handleDeleteExpense = () => {
    // Here you would add the API call to delete the expense
    deleteExpenseApi(selectedExpense.id)
      .then(() => {
        fetchExpensesList();
        setDeleteModal(false);
        toast.success("Expense deleted successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      })
      .catch(error => {
        toast.error(error?.response?.data?.error || "Error deleting expense!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true, 
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });

        console.error("Error deleting expense:", error);
      });
    
   
  }

  const columns = [
    // {
    //   title: "ID",
    //   dataIndex: "id",
    //   // sorter: true,
    //   render: (text, record, index) => (
    //     <h2 onClick={()=>{
    //       if(user?.id == record?.company_user.id){
    //         // console.log(record, "LLLLL")

    //         handleExpenseAction(record)
    //       }else{
    //         // console.log(record, "SSSSSSS")

    //         handleExpenseStatusAction(record)
    //       }
    //     }}  className="table-avatar d-flex">
    //      {text}
    //     </h2>
    //   ),
    //   sorter: (a, b) => a.id - b.id, 
    //   defaultSortOrder: "ascend"

    // },
    {
      title: "Name",
      dataIndex: "company_user__first_name",
      sorter: true,
      render: (text, record, index) => (
        <h2 onClick={()=>{

          if(user?.id == record?.company_user.id){
            handleExpenseAction(record)
          }else{
            handleExpenseStatusAction(record)
          }
          
          }}  className="table-avatar d-flex">
          <a 
          
          className="avatar">
            {/* <img alt="" src={record.profile_image} /> */}
            <Image src={record?.company_user?.profile_image}  type="user" style={{ objectFit: "cover" }} />
          </a>
          <div>
          <a 
          // onClick={()=>handleEmployeeDetailPage(record.id, index)} 
          className="profile-split d-flex flex-column">
            {record.company_user?.first_name} {record?.company_user?.last_name} 
          </a>
          {record?.company_user?.emp_no && (
            <span className="small text-muted">{ record.company_user?.emp_no}</span>
          )}

        
          </div>
        </h2>
      ),

    },
    // {
    //   title: "Position",
    //   dataIndex: "position_name",
    //   // sorter: true,
    //   render: (text, record, index) => (       
    //       <span>{record?.company_user?.position_name}</span>        
     
    //   ),
    //   align:"center"

    // },
    // {
    //   title: "Claim No",
    //   dataIndex: "claim_no",
    //   render: (text,record) => <span>{text}</span>,
    //   sorter: true,
    // },
    // {
    //   title: "Ref Date",
    //   dataIndex: "reference_date",
    //   render: (text,record) => <span>{formatDateHandler2(text)}</span>,
    //   sorter:true,
    // },

    {
      title: "Posting Date",
      dataIndex: "posting_date",
      render: (text) => <span>{formatDateHandler2(text)}</span>,

      sorter:true,
      align:"center"
    },
    
    {
      title: "Created Date",
      dataIndex: "created_at",
      render: (text) => <span>{formatDateHandler2(text)}</span>,

      sorter:true,
      align:"center"
    },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   render: (text) => <span>{text}</span>,

    //   sorter: true,
    //   align:"center"
    // },

 
    {
      title: "Status",
      dataIndex: "approval_status",
      sorter: true,
      align: "center",
      render: (text) => (
        <div className="dropdown action-label text-center">
         <span
          className={`badge badge-soft-${
            text === "pending"
              ? "warning"  // Yellow
              : text === "approved"
              ? "success"  // Green
              : text === "cancelled"
              ? "dark" // Grey
              : "danger"  
  }`}
>
  {text}
</span>

        </div>
      ),
    },
 
        {
      title: "Cost  Center",
      dataIndex: "cost_center",
      render: (text, record) => <span>{record?.cost_center?.code || ""}</span>,

      sorter: true,
      align:"center"
    },
    {
      title: "Current Approver",
      dataIndex: "current_approver__first_name",
      sorter: true,
      render: (text, record) => (
        <h2 className="table-avatar d-flex">
          {
            record?.current_approver &&
            <>
                    <a 
        // onClick={()=>handleEmployeeDetailPage(record.id, index)} 
        className="avatar">
          {/* <img alt="" src={record.profile_image} /> */}
          <Image src={record?.current_approver?.profile_image}  type="user" style={{ objectFit: "cover" }} />
        </a>
        <a 
        // onClick={()=>handleEmployeeDetailPage(record.id, index)} 
        className="profile-split d-flex flex-column">
          {record.current_approver?.first_name} {record?.current_approver?.last_name}
          {record?.current_approver?.emp_no && (
            <span className="small text-muted">{ record.current_approver.emp_no}</span>
          )}
        </a>
            </>
          }

      </h2>
      ),
    },
    {
      title: "Approved on",
      dataIndex: "approved_on",
      render: (text) => <span>{formatDateHandler2(text)}</span>,

      sorter: true,
    },
    {
      title: "Action",
      className: "text-end",
      sorter: true,
      render: (text,record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              onClick={()=>{
                if(user?.id == record?.company_user.id){
                  handleExpenseAction(record)
                }else{
                  handleExpenseStatusAction(record)
                }
              }}
            >
              <i className="fa fa-pencil m-r-5" /> Update
            </Link>
            {user?.id == record?.company_user.id  && record?.approval_status == "pending" && (
              <Link
                className="dropdown-item"
                to="#"
                onClick={() => handleDeleteAction(record)}
              >
                <i className="fa fa-trash m-r-5" /> Delete
              </Link>
            )}
          </div>
        </div>
      ),
    },
  ];
  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {expenses.map((record, index) => (
            <div
              className="col-12 col-sm-6 col-md-4 col-lg-3"
              key={record.id}
              style={{
                ...(isMobile ? { paddingLeft: "4px", paddingRight: "4px", marginBottom: "12px" } : { marginBottom: "16px" }),
                display: "flex"
              }}
            >
              <div className="card shadow-sm" style={{ 
                borderRadius: "8px", 
                border: "none",
                background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)",
                margin: 0,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                position: "relative",
                overflow: "hidden",
                cursor: "pointer",
                transition: "all 0.2s ease",
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
              }}
              onClick={() => {
                if(user?.id == record?.company_user.id){
                  handleExpenseAction(record)
                }else{
                  handleExpenseStatusAction(record)
                }
              }}
              >
                <div className="card-body" style={{ 
                  padding: isMobile ? "12px" : "16px",
                  flex: 1,
                  display: "flex",
                  flexDirection: "column"
                }}>
                  {/* User Avatar and Name */}
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "12px"
                  }}>
                    <div style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "50%",
                      overflow: "hidden",
                      border: "2px solid #e5e7eb",
                      flexShrink: 0,
                      background: "#ffffff"
                    }}>
                      <Image
                        src={record.company_user?.profile_image}
                        type="user"
                        alt="User Image"
                        style={{ 
                          objectFit: "cover",
                          width: "100%",
                          height: "100%"
                        }}
                      />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ 
                        fontSize: "13px", 
                        color: "#1f2937",
                        fontWeight: "600",
                        marginBottom: "2px"
                      }}>
                        {record.company_user?.first_name} {record?.company_user?.last_name}
                      </div>
                      {record.company_user?.emp_no && (
                        <div style={{ 
                          fontSize: "11px", 
                          color: "#6b7280",
                          marginBottom: "2px"
                        }}>
                          {record.company_user.emp_no}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Expense Details */}
                  <div style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column"
                  }}>
                    <div className="row g-2" style={{ marginBottom: "10px" }}>
                      {record?.reference_date && (
                        <div className="col-6">
                          <div style={{ fontSize: "10px", color: "#9ca3af", marginBottom: "3px", fontWeight: "500" }}>
                            <i className="la la-calendar" style={{ marginRight: "4px" }}></i>
                            Reference
                          </div>
                          <div style={{ fontSize: "11px", color: "#374151", fontWeight: "500" }}>
                            {formatDateHandler2(record.reference_date)}
                          </div>
                        </div>
                      )}
                      {record?.created_at && (
                        <div className="col-6">
                          <div style={{ fontSize: "10px", color: "#9ca3af", marginBottom: "3px", fontWeight: "500" }}>
                            <i className="la la-calendar-check" style={{ marginRight: "4px" }}></i>
                            Created
                          </div>
                          <div style={{ fontSize: "11px", color: "#374151", fontWeight: "500" }}>
                            {formatDateHandler2(record.created_at)}
                          </div>
                        </div>
                      )}
                      {record?.posting_date && (
                        <div className="col-6">
                          <div style={{ fontSize: "10px", color: "#9ca3af", marginBottom: "3px", fontWeight: "500" }}>
                            <i className="la la-calendar-week" style={{ marginRight: "4px" }}></i>
                            Posting
                          </div>
                          <div style={{ fontSize: "11px", color: "#374151", fontWeight: "500" }}>
                            {formatDateHandler2(record.posting_date)}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Cost Center and Status Badge on same line */}
                    <div style={{
                      marginBottom: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "8px",
                      flexWrap: "wrap"
                    }}>
                      {record?.cost_center?.code && (
                        <div style={{ 
                          fontSize: "10px",
                          color: "#6b7280",
                          fontWeight: "500",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px"
                        }}>
                          <span style={{ color: "#9ca3af" }}>CC:</span>
                          <span>{record.cost_center.code}</span>
                        </div>
                      )}
                      {record?.approval_status && (
                        <span
                          className={`badge badge-soft-${
                            record?.approval_status === "pending"
                              ? "warning"
                              : record?.approval_status === "approved"
                              ? "success"
                              : record?.approval_status === "cancelled"
                              ? "dark"
                              : "danger"
                          }`}
                          style={{
                            fontSize: "10px",
                            fontWeight: "600",
                            padding: "3px 6px",
                            borderRadius: "4px"
                          }}
                        >
                          {record.approval_status}
                        </span>
                      )}
                    </div>

                    {/* Current Approver */}
                    {record?.current_approver && (
                      <div style={{
                        marginTop: "auto",
                        paddingTop: "10px",
                        borderTop: "1px solid #e5e7eb"
                      }}>
                        <div style={{ fontSize: "10px", color: "#9ca3af", marginBottom: "3px", fontWeight: "500" }}>
                          <i className="la la-user" style={{ marginRight: "4px" }}></i>
                          Current Approver
                        </div>
                        <div style={{ fontSize: "11px", color: "#374151", fontWeight: "500" }}>
                          {record.current_approver.first_name}{" "}
                          {record.current_approver.last_name}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };

  const handleGridChange = (page, size) =>{
    console.log(page, size, ")))))))))))))")
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Expenses"
            title="Dashboard"
            subtitle="Expenses"
            modal="#add_expense"
            name="Create Expense"
            setExpenseModal={setExpenseModal}
            // hideGrid={true}
            link="/create-expense"
            view={view}
            setView={setView}
          />


{/* {user.role?.access_scope !== "self" &&  // requested to remove filter on 3-oct-2025 */}
<div className="row" >
          <ExpensesFilter
           filters={filters} 
           handleInputChange={handleInputChange} 
           searchPlaceholder={"Search expenses"} 
           handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
            appliedFilterCount={appliedFilterCount}
             />
          </div>
          {/* } */}

          
          

        {view == "grid" ? (
            <div className="row">
              {/* <div className="my-2" >
            <SearchBox handleChange={handleGridChange} pageSettings={pageSettings} setPageSettings={setPageSettings} />
            
            </div> */}
              <GridView />

              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                  <Pagination

                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}

                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            className="btn btn-primary"
                            label="Load More"
                            style={{ background: primaryRedGradient, border: "none" }}
                          />
                        );
                      }
                      return null;
                    }}

                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-12">
                <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                  <style>{`
                    .modern-table .ant-table-tbody > tr {
                      background-color: #ffffff !important;
                    }
                    .modern-table .ant-table-tbody > tr:hover > td {
                      background-color: #f5f5f5 !important;
                    }
                    .modern-table .ant-table-thead > tr > th {
                      background-color: #f8f9fa !important;
                      font-weight: 600;
                      color: #333;
                      border-bottom: 2px solid #e0e0e0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-tbody > tr > td {
                      border-bottom: 1px solid #f0f0f0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-wrapper .ant-table-pagination.ant-pagination {
                      border-top: 1px solid #f0f0f0;
                      background-color: #ffffff;
                      border-bottom-left-radius: 12px;
                      border-bottom-right-radius: 12px;
                    }
                  `}</style>
                  <div className="table-responsive" style={{ overflowX: "auto" }}>
                    <Table
                      className="mb-0 modern-table"
                      style={{ 
                        borderRadius: "12px",
                        minWidth: "100%"
                      }}
                      scroll={{ x: "max-content" }}
                      columns={columns}
                      dataSource={expenses}
                      rowKey={(record) => record.id}
                      loading={expensesLoading}
                      pagination={{
                        total: pageSettings?.total,
                        pageSize: pageSettings?.pageSize,
                        showSizeChanger: true,
                        pageSizeOptions: pageSizeOptions,
                        itemRender: itemRender,
                        position: "right",
                        current: pageSettings?.page,
                        showTotal: (total, range) =>
                          `${range[0]}-${range[1]} of ${total} items`,
                        style: { padding: "16px" }
                      }}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}


        </div>
      </div>
      <DeleteModal 
      deleteModal={deleteModal}
      setDeleteModal={setDeleteModal}
      deleteHandler={handleDeleteExpense}
      Name="Delete Expense"



        // Name="Delete Expense" 
        // show={deleteModal}
        // onHide={() => setDeleteModal(false)}
        // onDelete={handleDeleteExpense}
        // message={`Are you sure you want to delete expense #${selectedExpense?.id}?`}
      />


      <FilterDrawer


        searchPlaceholder={"Search expenses"}
        showFilterDrawer={showFilterDrawer}
        handleFilterDrawer={handleFilterDrawer}

        handleFilterChange={handleFilterChange}
        filters={filters}
        handleInputChange={handleInputChange}
        handleApplyFilter={handleApplyFilter}
        filterLoading={filterLoading}
        handleDateChange={handleDateChange}
      
      />

{
  expenseModal && (
    <ExpenseModal fetchExpenseList={fetchExpensesList} expenseData={selectedExpense} setExpenseData={setSelectedExpense}   expenseModal={expenseModal} setExpenseModal={setExpenseModal} user={user} />
  )
}

<ExpenseStatusModal fetchExpenseList={fetchExpensesList} expenseData={selectedExpense} setExpenseData={setSelectedExpense}   expenseModal={expenseStatusModal} setExpenseModal={setExpenseStatusModal} user={user} />

    </>
  );
};

export default Estimates;
